/**
 * AvailabilityTypeItem.jsx
 * Created by Destin Frasier on 03/04/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    name: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    availClass: PropTypes.string.isRequired,
    altTitle: PropTypes.string.isRequired
};

const AvailabilityTypeItem = ({ name, text, availClass, altTitle }) => (
    <div className="rec-availability-item">
        <div
            className={`rec-availability-block rec-${availClass}`}
            key={name}
            title={altTitle}
            role="img"
            alt={altTitle}>
            {text}
        </div>
        <div className="rec-availability-item-type">
            {name}
        </div>
    </div>

);

AvailabilityTypeItem.propTypes = propTypes;

export default AvailabilityTypeItem;
